export default "__VITE_ASSET__Dnw8Hyvv__"